module.exports = __webpack_public_path__ + "media/images/smart_phone/post_kuchikomi_btn_s_ov2-a56b6fcf7ef44319e5b22b6865c5e567.png";